import React from 'react';

import './style.scss';

const Note = ({ children }) => <span className="note">{children}</span>;

const Price = ({ children }) => <span className="amount">{children}</span>;

const FareTable = () => (
  <div>
    <div className="row price-chart justify-content-md-center">
      <div className="col-md-4">
        <h5>One-Way</h5>
        <ul>
          <li>
            Adult: <Price>$13</Price>
          </li>
          <li>
            Child: <Price>$7</Price> <Note>(Ages 2-11)</Note>
          </li>
          <li>
            Senior: <Price>$12</Price> <Note>(With valid suffolk ID)</Note>
          </li>
          <li>
            Handicapped: <Price>$12</Price> <Note>(With valid ID)</Note>
          </li>
          <li>
            Military: <Price>$12</Price>{' '}
            <Note>(With valid veteran or active military ID)</Note>
          </li>
        </ul>
      </div>
      <div className="col-md-4">
        <h5>Round-Trip</h5>
        <ul>
          <li>
            Adult: <Price>$25</Price>
          </li>
          <li>
            Child: <Price>$13</Price> <Note>(Ages 2-11)</Note>
          </li>
        </ul>
      </div>
      <div className="col-md-4">
        <h5>40-Trip Book</h5>
        <ul>
          <li>
            Adult: <Price>$442</Price>
          </li>
          <li>
            Child: <Price>$221</Price> <Note>(Ages 2-11)</Note>
          </li>
        </ul>
      </div>
    </div>
    <p className="fare-text">
      <i className="far fa-dog" /> Dogs will be charged a child's fare and must
      be leashed at all times on the ferries and on the terminal propery.
    </p>
  </div>
);

export default FareTable;
